
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/medical",
      function () {
        return require("private-next-pages/learn/medical/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/medical"])
      });
    }
  